import { useField } from 'formik';
import { DateTime } from 'luxon';
import { AdapterLuxon } from '@mui/x-date-pickers/AdapterLuxon';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { TimePicker } from '@mui/x-date-pickers';

const TimePickerField = ({ name, label, size = "small", fullWidth = true, styles, ...props }) => {
  const [field, , helpers] = useField(name);

  // Ensure value is a Luxon DateTime object or null
  const currentValue = field.value 
    ? (DateTime.isDateTime(field.value) ? field.value : DateTime.fromJSDate(new Date(field.value)))
    : null;

  return (
    <LocalizationProvider dateAdapter={AdapterLuxon}>
      <TimePicker
        {...props}
        label={label}
        value={currentValue}
        // Direct update to Formik state
        onChange={(newValue) => helpers.setValue(newValue)}
        slotProps={{ textField: { size, fullWidth } }}
        sx={styles}
      />
    </LocalizationProvider>
  );
};

export default TimePickerField;